import { TextInput } from "components/FormControls/TextInput";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { useStyles } from "../../styles";

interface Props {
  index: number;
  size: "small" | "medium" | "inline";
  onChange?: () => void;
  dataHjSuppress?: boolean;
}

export const Number = memo(
  ({ index, size, onChange, dataHjSuppress }: Props) => {
    const { message } = useMessage();
    const classes = useStyles();
    const isInlineType = size === "inline";

    return (
      <TextInput
        className={isInlineType ? classes.inlineValue : ""}
        name={`filters.${index}.value`}
        size={isInlineType ? "small" : size}
        placeholder={message({ id: "value" })}
        data-test-id="filter-value"
        adjustWidthToValue={isInlineType}
        data-hj-suppress={dataHjSuppress}
        type="number"
        customOnBlur={() => {
          if (isInlineType && onChange) {
            onChange();
          }
        }}
      />
    );
  },
);
